import "./App.css";
import React from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";
import Menu from "./components/Menu";
import Home from "./components/Home";
import About from "./components/About";
import ContactUs from "./components/ContactUs";
import MediaPublications from "./components/MediaPublications";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import IPhone11ProMax17 from "./components/IPhone11ProMax17";
import IPhone11ProMax18 from "./components/IPhone11ProMax18";
import IPhone11ProMax19 from "./components/IPhone11ProMax19";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/menu">
          <Menu {...menuData} />
        </Route>
        <Route path="/home">
          <Home {...homeData} />
        </Route>
        <Route path="/:path(|about)">
          <About {...aboutData} />
        </Route>
        <Route path="/contact-us">
          <ContactUs {...contactUsData} />
        </Route>
        <Route path="/media-publications">
          <MediaPublications {...mediaPublicationsData} />
        </Route>
        <Route path="/services">
          <Services
            ourServices="Our Services"
            sohniJunejaIsAWe={
              <>
                Sohni Juneja is a well Known Makeup Artist in Delhi for doing professional bridal makeup, party makeup
                and hairstyling. Her bridal services are tailored to meet the needs and requirements of the clients.
                Sohni J provides hairstyling, engagement makeup, bridal makeup as well as party makeup services. In
                addition to these, she also provides bridal makeup appointment, pre- wedding makeup tips, product
                recommendation to get the best of your look on your special day. Apart from the services, she also gives
                you special offers in hairstyling as well as bridal makeup.
                <br />
                <br />
                Professional makeup artist, Sohni Juneja not only provides you all the services at her makeup studio but
                also at your respective venue. To give you smooth and hassle free makeover experience, she also travels
                within the city, outstations and at your doorstep as well.
              </>
            }
            phoneNavProps={servicesData.phoneNavProps}
            property1DefaultProps={servicesData.property1DefaultProps}
          />
        </Route>
        <Route path="/gallery">
          <Gallery
            gallery="Gallery"
            phoneNavProps={galleryData.phoneNavProps}
            property1Frame293Props={galleryData.property1Frame293Props}
          />
        </Route>
        <Route path="/iphone-11-pro-max-17">
          <IPhone11ProMax17 {...iPhone11ProMax17Data} />
        </Route>
        <Route path="/iphone-11-pro-max-18">
          <IPhone11ProMax18 {...iPhone11ProMax18Data} />
        </Route>
        <Route path="/iphone-11-pro-max-19">
          <IPhone11ProMax19 {...iPhone11ProMax19Data} />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
const frame3021Data = {
    className: "",
};

const frame3041Data = {
    frame302Props: frame3021Data,
};

const menuData = {
    overlapGroup: "/img/line-78@2x.png",
    line79: "/img/line-79@2x.png",
    place: "Home",
    line80: "/img/line-80@2x.png",
    aboutUs: "About Us",
    line81: "/img/line-80@2x.png",
    services: "Services",
    line82: "/img/line-80@2x.png",
    mediaPublications: "Media Publications",
    line83: "/img/line-80@2x.png",
    gallery: "Gallery",
    line84: "/img/line-80@2x.png",
    blog: "Blog",
    line85: "/img/line-80@2x.png",
    contactUs: "Contact Us",
    line86: "/img/line-80@2x.png",
    frame304Props: frame3041Data,
};

const phoneNav1Data = {
    image22: "/img/image-22@2x.png",
};

const group277Data = {
    src: "/img/more-than-1@2x.png",
};

const group2782Data = {
    className: "group-279",
};

const group2783Data = {
    className: "group-280",
};

const group2784Data = {
    className: "group-281",
};

const property1Frame271Data = {
    rectangle30: "/img/rectangle-30@2x.png",
    moreThan: "/img/more-than@2x.png",
    rectangle391: "/img/rectangle-39--1-@2x.png",
    rectangle382: "/img/rectangle-38--2-@2x.png",
    group277Props: group277Data,
    group2781Props: group2782Data,
    group2782Props: group2783Data,
    group2783Props: group2784Data,
};

const property1Frame272Data = {
    bridalLook: "Bridal look",
    rectangle321: "/img/rectangle-32-1@2x.png",
    party: "Party",
    fashion: "Fashion",
    surname: "Day Look",
    rectangle14: "/img/rectangle-14@2x.png",
    rectangle33: "/img/rectangle-33@2x.png",
    rectangle322: "/img/rectangle-32@2x.png",
    property1Frame271Props: property1Frame271Data,
};

const aboutFalseData = {
    aboutSohniJuneja: "ABOUT SOHNI JUNEJA",
    line12: "/img/line-12-1@2x.png",
};

const bookFalseData = {
    rectangle32: "/img/rectangle-32-2@2x.png",
    bookServices: "BOOK SERVICES",
    line16: "/img/line-12-1@2x.png",
};

const schoolFalseData = {
    sohniJunejaSchoolOfMakeup: "SOHNI JUNEJA SCHOOL OF MAKEUP",
    line17: "/img/line-12-1@2x.png",
};

const property1Frame18Data = {
    ellipse6: "/img/ellipse-6@2x.png",
    vatsalaWilson: "Vatsala Wilson",
    loremIpsumDolorSi: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec posuere mauris, ut lacinia lectus. Donec ut enim mauris. Sed molestie Lorem ipsum dolor sit amet,",
};

const group2861Data = {
    src: "/img/more-than-6@2x.png",
};

const group2862Data = {
    src: "/img/more-than-7@2x.png",
    className: "group-287-1",
};

const group2562Data = {
    className: "group-257-1",
};

const group2582Data = {
    className: "group-259-1",
};

const property1Frame182Data = {
    rectangle201: "/img/rectangle-20@2x.png",
    rosewaterBenefits1: "ROSEWATER BENEFITS: FROM ANTIOXIDANTS TO ANTI-AGING",
    rectangle202: "/img/rectangle-20-1@2x.png",
    excitingEyeMakeupTrendsIn2021: "EXCITING EYE MAKEUP TRENDS IN 2021",
    rectangle203: "/img/rectangle-20-2@2x.png",
    rosewaterBenefits2: "ROSEWATER BENEFITS: FROM ANTIOXIDANTS TO ANTI-AGING",
    group2861Props: group2861Data,
    group2862Props: group2862Data,
    group256Props: group2562Data,
    group258Props: group2582Data,
};

const frame431Data = {
    line36: "/img/line-36@2x.png",
    className: "",
};

const fAQ1False1Data = {
    frame43Props: frame431Data,
};

const frame4321Data = {
    line36: "/img/line-36@2x.png",
    className: "",
};

const fAQ2False1Data = {
    frame432Props: frame4321Data,
};

const frame4331Data = {
    line36: "/img/line-36@2x.png",
    className: "",
};

const fAA3False1Data = {
    frame433Props: frame4331Data,
};

const frame4341Data = {
    line36: "/img/line-36@2x.png",
    className: "",
};

const fAQ4False1Data = {
    frame434Props: frame4341Data,
};

const homeData = {
    image16: "/img/image-16@2x.png",
    followUsOn: "Follow Us On",
    image17: "/img/image-17@2x.png",
    screenshot20220312At1229: "/img/screenshot-2022-03-12-at-12-29@2x.png",
    screenshot20220312At1230: "/img/screenshot-2022-03-12-at-12-30@2x.png",
    testimonials: "TESTIMONIALS",
    blog: "BLOG",
    accolades: "ACCOLADES",
    x1: "/img/1@2x.png",
    x2: "/img/2@2x.png",
    x3: "/img/3@2x.png",
    x4: "/img/4@2x.png",
    phoneNavProps: phoneNav1Data,
    property1Frame272Props: property1Frame272Data,
    aboutFalseProps: aboutFalseData,
    bookFalseProps: bookFalseData,
    schoolFalseProps: schoolFalseData,
    property1Frame18Props: property1Frame18Data,
    property1Frame182Props: property1Frame182Data,
    fAQ1FalseProps: fAQ1False1Data,
    fAQ2FalseProps: fAQ2False1Data,
    fAA3FalseProps: fAA3False1Data,
    fAQ4FalseProps: fAQ4False1Data,
};

const phoneNav2Data = {
    image22: "/img/image-22-1@2x.png",
    className: "phone-nav-1",
};

const footer2Data = {
    className: "footer-1",
};

const footer31Data = {
    footerProps: footer2Data,
};

const footer22Data = {
    footer3Props: footer31Data,
};

const aboutData = {
    aboutUs: "About Us",
    rectangle5: "/img/rectangle-5@2x.png",
    spanText1: "Sohni Juneja",
    spanText2: ", a product of ",
    spanText3: "National Institute of Fashion Technology (Delhi) ",
    spanText4: <>where she got her proficiency in her passion for Designing and Styling. During the tenure of the course, she interned with the Designer Duo, Aashima and Leena and later joined the prestigious label of Designer Raghavendra Rathore as a stylist and made her presence felt.<br /><br />You made me feel so comfortable (not to forget the soft brush touch, asmr feeling), I couldn&#x27;t have picked a better makeup artist.</>,
    spanText5: "Her Quest for adding more feathers to her cap and wanting to have the ability to give people a whole body makeover took her to Pearl Academy, in association with Developments at ",
    spanText6: "London Institute (DALI)",
    spanText7: " at ",
    spanText8: "London College of Fashion",
    spanText9: <>, where she took up Fashion Media Makeup and topped her Batch.<br /><br />Emoting with the feminine desires of looking their best on their special day, </>,
    spanText10: "Sohni Juneja",
    spanText11: <> has vowed many a bride with her power to transform. She understands what works on models for the runways must be translated differently for the everyday woman. With her dainty, yet sure strokes she can take you to completely different <br /><br />realms, from Smokey to well-defined, she masters it all, wanting to add drama to each look differently every time.</>,
    famousBridalMakeupArtistInDelhi: "Famous Bridal Makeup Artist In Delhi",
    sohniJunejaIsAnE: <>Sohni Juneja is an extremely famous bridal makeup artist in Delhi. A professional with experience, Sohni Juneja is skilled and truly an expert in every sense of the word. Creative and incredibly passionate, she transforms every bride into nothing short of a dream. With her professionalism, Sohni Juneja can hide anything you consider a shortcoming, and assist you to exude an unmatched level of confidence.<br /><br />She is the makeup artist you need if you&#x27;re in search of a glam look for your wedding day. Each bride is unique and so are her needs. To exhibit the beauty of her clients, she grasps the essence of this understanding.</>,
    phoneNavProps: phoneNav2Data,
    footer2Props: footer22Data,
};

const phoneNav3Data = {
    image22: "/img/image-22-1@2x.png",
    className: "phone-nav-2",
};

const frame1482Data = {
    className: "frame-137",
};

const frame435Data = {
    line36: "/img/line-36@2x.png",
    className: "frame-43-1",
};

const fAQ1False2Data = {
    className: "faq1-1",
    frame43Props: frame435Data,
};

const frame4322Data = {
    line36: "/img/line-36@2x.png",
    className: "frame-43-3",
};

const fAQ2False2Data = {
    className: "faq2-1",
    frame432Props: frame4322Data,
};

const frame4332Data = {
    line36: "/img/line-36@2x.png",
    className: "frame-43-5",
};

const fAA3False2Data = {
    className: "faq3-1",
    frame433Props: frame4332Data,
};

const frame4342Data = {
    line36: "/img/line-36@2x.png",
    className: "frame-43-7",
};

const fAQ4False2Data = {
    className: "faq4-1",
    frame434Props: frame4342Data,
};

const frame3022Data = {
    className: "frame-302-1",
};

const frame3042Data = {
    className: "frame-303",
    frame302Props: frame3022Data,
};

const contactUsData = {
    contactUs: "Contact  Us",
    welcomeToTheConta: "Welcome to the contact page of Sohni Juneja",
    findOutEverything: "Find out  everything related to our policies and FAQs",
    bookAnAppointment: "Book an appointment through the contact details provided below.",
    callUs: "CALL US",
    phone1: "+91-9999963537",
    monFri8Am8Pm1: "Mon-Fri  8am - 8pm",
    emailUs: "EMAIL US",
    junejasohniGmailCom: "junejasohni@gmail.com",
    text1: "24*7",
    whatsapp: "WHATSAPP",
    phone2: "+91-9999963537",
    monFri8Am8Pm2: "Mon-Fri  8am - 8pm",
    bookAppointment: "BOOK APPOINTMENT",
    phone3: "+91-9999963537",
    monFri8Am8Pm3: "Mon-Fri  8am - 8pm",
    address: "ADDRESS",
    r2552NdFloor: "R - 255, 2nd Floor, G K- 1, Delhi - 110048",
    x123LaneOppSai: "123, lane, opp. Sai Temple, Emerald Hills, Dehradun- 248001",
    phoneNavProps: phoneNav3Data,
    frame148Props: frame1482Data,
    fAQ1FalseProps: fAQ1False2Data,
    fAQ2FalseProps: fAQ2False2Data,
    fAA3FalseProps: fAA3False2Data,
    fAQ4FalseProps: fAQ4False2Data,
    frame304Props: frame3042Data,
};

const phoneNav4Data = {
    image22: "/img/image-22-1@2x.png",
    className: "phone-nav-3",
};

const footer4Data = {
    className: "footer-2",
};

const footer32Data = {
    footerProps: footer4Data,
};

const footer23Data = {
    footer3Props: footer32Data,
};

const mediaPublicationsData = {
    mediaPublications: "Media Publications",
    x135: "/img/135@2x.png",
    x136: "/img/136@2x.png",
    x139: "/img/139@2x.png",
    x137: "/img/137@2x.png",
    x138: "/img/138@2x.png",
    viewMore: "View More",
    phoneNavProps: phoneNav4Data,
    footer2Props: footer23Data,
};

const phoneNav5Data = {
    image22: "/img/image-22-1@2x.png",
    className: "phone-nav-4",
};

const hairstylingOnData = {
    hairStyling: "HAIR STYLING",
};

const bridalMakeup1Data = {
    children: "BRIDAL MAKEUP",
};

const partyMakeup1Data = {
    children: "PARTY MAKEUP",
};

const bridalMakeupOnData = {
    polygon33: "/img/polygon-33@2x.png",
    bridalMakeup: "BRIDAL MAKEUP",
};

const bridalMakeup2Data = {
    children: "PARTY MAKEUP",
    className: "party-makeup-1",
};

const offers2Data = {
    className: "offers-3",
};

const group2222Data = {
    className: "group-222-1",
};

const hairStyling2Data = {
    className: "hair-styling-4",
};

const bridalMakeup3Data = {
    children: "BRIDAL MAKEUP",
    className: "bridal-makeup-2",
};

const partyMakeupOnData = {
    polygon34: "/img/polygon-33@2x.png",
    partyMakeup: "PARTY MAKEUP",
};

const offers3Data = {
    className: "offers-4",
};

const hairStyling3Data = {
    className: "hair-styling-5",
};

const bridalMakeup4Data = {
    children: "BRIDAL MAKEUP",
    className: "bridal-makeup-3",
};

const bridalMakeup5Data = {
    children: "PARTY MAKEUP",
    className: "party-makeup-2",
};

const offersOnData = {
    polygon35: "/img/polygon-35@2x.png",
    offers: "OFFERS",
};

const group2224Data = {
    className: "group-222-2",
};

const property1DefaultData = {
    hairStyling: "HAIR STYLING",
    rectangle115: "/img/rectangle-115@2x.png",
    asMakeupPlaysAnI1: <>As Makeup plays an important role in glamorizing the look of a person. It is always a great desire of every woman to look her best on her special day.<br /><br />From the elaborate and traditional, to the trendy and quirky, our experienced hands can give any twist to your tresses. Sohni Juneja provides hair style &amp; hair extension service from eccentric to knotty, to cultural and with latest tradition, you can get adorable look so that every eye can appreciate your look on the big day.</>,
    sohniJunejaIsARe1: <>Sohni Juneja is a renowned professional makeup artist in Dehradun and Delhi. Having enormous knowledge about makeup and styling, she very well knows how to give attractive and charming look to her clients. She has been involved in providing her services of makeover to some well known T.V artists as well as celebs. She is successfully transforming lives of the women by making them beautiful.<br /><br />Get sensational look and let everyone adore your beauty with<br />Delhi best makeup artist at affordable rates. Call us or book your<br />appointment with Best wedding Makeup Artist in Delhi.</>,
    bridalMakeup: "BRIDAL MAKEUP",
    rectangle121: "/img/rectangle-121@2x.png",
    asMakeupPlaysAnI2: <>As Makeup plays an important role in glamorizing the look of a person. It is always a great desire of every woman to look her best on her special day.<br /><br />From the elaborate and traditional, to the trendy and quirky, our experienced hands can give any twist to your tresses. Sohni Juneja provides hair style &amp; hair extension service from eccentric to knotty, to cultural and with latest tradition, you can get adorable look so that every eye can appreciate your look on the big day.</>,
    sohniJunejaIsARe2: <>Sohni Juneja is a renowned professional makeup artist in Dehradun and Delhi. Having enormous knowledge about makeup and styling, she very well knows how to give attractive and charming look to her clients. She has been involved in providing her services of makeover to some well known T.V artists as well as celebs. She is successfully transforming lives of the women by making them beautiful.<br /><br />Get sensational look and let everyone adore your beauty with<br />Delhi best makeup artist at affordable rates. Call us or book your<br />appointment with Best wedding Makeup Artist in Delhi.</>,
    partyMakeup: "PARTY MAKEUP",
    rectangle127: "/img/rectangle-127@2x.png",
    asMakeupPlaysAnI3: <>As Makeup plays an important role in glamorizing the look of a person. It is always a great desire of every woman to look her best on her special day.<br /><br />From the elaborate and traditional, to the trendy and quirky, our experienced hands can give any twist to your tresses. Sohni Juneja provides hair style &amp; hair extension service from eccentric to knotty, to cultural and with latest tradition, you can get adorable look so that every eye can appreciate your look on the big day.</>,
    sohniJunejaIsARe3: <>Sohni Juneja is a renowned professional makeup artist in Dehradun and Delhi. Having enormous knowledge about makeup and styling, she very well knows how to give attractive and charming look to her clients. She has been involved in providing her services of makeover to some well known T.V artists as well as celebs. She is successfully transforming lives of the women by making them beautiful.<br /><br />Get sensational look and let everyone adore your beauty with<br />Delhi best makeup artist at affordable rates. Call us or book your<br />appointment with Best wedding Makeup Artist in Delhi.</>,
    offers: "OFFERS",
    rectangle133: "/img/rectangle-133@2x.png",
    asMakeupPlaysAnI4: <>As Makeup plays an important role in glamorizing the look of a person. It is always a great desire of every woman to look her best on her special day.<br /><br />From the elaborate and traditional, to the trendy and quirky, our experienced hands can give any twist to your tresses. Sohni Juneja provides hair style &amp; hair extension service from eccentric to knotty, to cultural and with latest tradition, you can get adorable look so that every eye can appreciate your look on the big day.</>,
    sohniJunejaIsARe4: <>Sohni Juneja is a renowned professional makeup artist in Dehradun and Delhi. Having enormous knowledge about makeup and styling, she very well knows how to give attractive and charming look to her clients. She has been involved in providing her services of makeover to some well known T.V artists as well as celebs. She is successfully transforming lives of the women by making them beautiful.<br /><br />Get sensational look and let everyone adore your beauty with<br />Delhi best makeup artist at affordable rates. Call us or book your<br />appointment with Best wedding Makeup Artist in Delhi.</>,
    hairstylingOnProps: hairstylingOnData,
    bridalMakeup1Props: bridalMakeup1Data,
    partyMakeupProps: partyMakeup1Data,
    bridalMakeupOnProps: bridalMakeupOnData,
    bridalMakeup2Props: bridalMakeup2Data,
    offers1Props: offers2Data,
    group2221Props: group2222Data,
    hairStyling1Props: hairStyling2Data,
    bridalMakeup3Props: bridalMakeup3Data,
    partyMakeupOnProps: partyMakeupOnData,
    offers2Props: offers3Data,
    hairStyling2Props: hairStyling3Data,
    bridalMakeup4Props: bridalMakeup4Data,
    bridalMakeup5Props: bridalMakeup5Data,
    offersOnProps: offersOnData,
    group2222Props: group2224Data,
};

const servicesData = {
    phoneNavProps: phoneNav5Data,
    property1DefaultProps: property1DefaultData,
};

const phoneNav6Data = {
    image22: "/img/image-22-1@2x.png",
    className: "phone-nav-5",
};

const bridalGalleryOnData = {
    children: "BRIDAL MAKEUP",
};

const partyMakeup2Data = {
    children: "PARTY MAKEUP",
    className: "party-gallery",
};

const partyMakeup3Data = {
    children: "BEFORE/ AFTER",
    className: "before-after-gallery-1",
};

const partyGalleryOnData = {
    children: "PARTY MAKEUP",
};

const partyMakeup4Data = {
    children: "BEFORE/ AFTER",
    className: "before-after-gallery-1",
};

const bridalGallery2Data = {
    className: "bridal-gallery-1",
};

const partyMakeup5Data = {
    children: "PARTY MAKEUP",
    className: "party-gallery-1",
};

const beroreAfterGalleryOnData = {
    children: "BEFORE/ AFTER",
};

const editorialGallery3Data = {
    className: "editorial-gallery-1",
};

const bridalGallery3Data = {
    className: "bridal-gallery-2",
};

const partyMakeup6Data = {
    children: "PARTY MAKEUP",
    className: "party-gallery-2",
};

const bridalMakeup6Data = {
    children: "BEFORE/ AFTER",
    className: "before-after-gallery",
};

const editorialGalleryOnData = {
    children: "EDITORIAL",
};

const viewMoreGallery4Data = {
    className: "view-more-gallery-1",
};

const property1Frame293Data = {
    bridalGalleryOnProps: bridalGalleryOnData,
    partyMakeup1Props: partyMakeup2Data,
    partyMakeup2Props: partyMakeup3Data,
    partyGalleryOnProps: partyGalleryOnData,
    partyMakeup3Props: partyMakeup4Data,
    bridalGallery1Props: bridalGallery2Data,
    partyMakeup4Props: partyMakeup5Data,
    beroreAfterGalleryOnProps: beroreAfterGalleryOnData,
    editorialGalleryProps: editorialGallery3Data,
    bridalGallery2Props: bridalGallery3Data,
    partyMakeup5Props: partyMakeup6Data,
    bridalMakeupProps: bridalMakeup6Data,
    editorialGalleryOnProps: editorialGalleryOnData,
    viewMoreGalleryProps: viewMoreGallery4Data,
};

const galleryData = {
    phoneNavProps: phoneNav6Data,
    property1Frame293Props: property1Frame293Data,
};

const iPhone11ProMax17Data = {
    image22: "/img/image-22@2x.png",
    line16: "/img/line-16@2x.png",
    line17: "/img/line-16@2x.png",
    line31: "/img/line-16@2x.png",
    line301: "/img/line-30@2x.png",
    rectangle30: "/img/rectangle-30@2x.png",
    rectangle38: "/img/rectangle-38@2x.png",
    rectangle39: "/img/rectangle-39@2x.png",
    untitledDesign50: "/img/untitled-design--50-@2x.png",
    rectangle691: "/img/rectangle-69@2x.png",
    rectangle33: "/img/rectangle-69@2x.png",
    rectangle14: "/img/rectangle-69@2x.png",
    surname: "Day Look",
    partyLook: "Party Look",
    bridalLook1: "Bridal Look",
    engagementLook: <>Engagement<br />Look</>,
    rectangle70: "/img/rectangle-70@2x.png",
    vector2: "/img/vector-10@2x.png",
    aboutSohniJuneja: "ABOUT SOHNI JUNEJA",
    line302: "/img/line-30-1@2x.png",
    junejasohniGmailCom: "junejasohni@gmail.com",
    phone1: "+91-9999963537",
    phone2: "+91-9999963537",
    rectangle90: "/img/rectangle-90@2x.png",
    bridalLook2: "BRIDAL LOOK",
    event: "Event:",
    artist: "Artist:",
    payXxxxAmountNow: "*Pay xxxx amount now and pay remaining on the day of appointment.",
    payFullAmountTo: "*Pay full amount to confirm appointment.",
    selectDate: "Select Date:",
    selectTime: "Select Time:",
    advanceBooking: "Advance Booking",
    fullPayment: "Full Payment",
    location: "Location:",
    selectPaymentOption: "Select Payment Option",
    contactUs: "Contact Us",
    proceedToBook: "PROCEED TO BOOK",
    bookAppointment: "BOOK APPOINTMENT",
    ddMmYyyy: "DD/MM/YYYY*",
    select1: "Select",
    bridalLook3: "Bridal Look",
    select2: "Select",
    select3: "Select",
    vector3: "/img/vector-11@2x.png",
    vector4: "/img/vector-12@2x.png",
    vector5: "/img/vector-12@2x.png",
    vector6: "/img/vector-12@2x.png",
    line36: "/img/line-36@2x.png",
    whatsapp: "/img/whatsapp@2x.png",
    loremIpsumDolorSi: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec posuere mauris, ut lacinia lectus. Donec ut enim mauris. Sed molestie Lorem ipsum dolor sit amet,",
    sohniJuneja: "Sohni Juneja",
    rectangle692: "/img/rectangle-69-1@2x.png",
    readMore: "Read More",
};

const phoneCall2Data = {
    className: "phone-call-1",
};

const mail2Data = {
    className: "mail-1",
};

const iPhone11ProMax18Data = {
    confirmBooking: "CONFIRM BOOKING",
    rectangle98: "/img/rectangle-90@2x.png",
    otherDetails: "OTHER DETAILS",
    bridalLook1: "BRIDAL LOOK",
    event: "Event:",
    bridalLook2: "Bridal Look",
    artist: "Artist:",
    seniorSohniJuneja: "Senior Sohni Juneja",
    date1: "Date:",
    date2: "23/10/2022",
    time: "Time:",
    x1800Hrs: "18:00 Hrs",
    location: "Location:",
    sjStudioDehradun: "SJ Studio Dehradun",
    name: "Name:",
    enterName: "Enter Name",
    line39: "/img/line-39@2x.png",
    phoneNo: "Phone No:",
    email: "Email:",
    enterPhoneNumber: "Enter Phone Number",
    line40: "/img/line-39@2x.png",
    enterEmail: "Enter Email",
    line41: "/img/line-39@2x.png",
    paymentDetails: "PAYMENT DETAILS",
    advanceBookingAmountXxxxxxx: "Advance Booking Amount:     XXXXXXX",
    gstXxxxxxx: "GST :                                               XXXXXXX",
    line42: "/img/line-42@2x.png",
    totalXxxxxxx: "Total :                                             XXXXXXX",
    line43: "/img/line-42@2x.png",
    spanText1: "I agree to all the ",
    spanText2: "TERMS AND CONDITIONS",
    proceedToPayment: "PROCEED TO PAYMENT",
    line36: "/img/line-36@2x.png",
    contactUs: "Contact Us",
    whatsapp: "/img/whatsapp@2x.png",
    phone1: "+91-9999963537",
    phone2: "+91-9999963537",
    junejasohniGmailCom: "junejasohni@gmail.com",
    phoneCallProps: phoneCall2Data,
    mailProps: mail2Data,
};

const iPhone11ProMax19Data = {
    image22: "/img/image-22@2x.png",
    line16: "/img/line-16@2x.png",
    line17: "/img/line-16@2x.png",
    line31: "/img/line-16@2x.png",
    line301: "/img/line-30@2x.png",
    rectangle30: "/img/rectangle-30@2x.png",
    rectangle38: "/img/rectangle-38@2x.png",
    rectangle39: "/img/rectangle-39@2x.png",
    untitledDesign50: "/img/untitled-design--50-@2x.png",
    rectangle691: "/img/rectangle-69@2x.png",
    rectangle33: "/img/rectangle-69@2x.png",
    rectangle14: "/img/rectangle-69@2x.png",
    surname: "Day Look",
    partyLook: "Party Look",
    bridalLook1: "Bridal Look",
    engagementLook: <>Engagement<br />Look</>,
    rectangle70: "/img/rectangle-70@2x.png",
    vector2: "/img/vector-10@2x.png",
    aboutSohniJuneja: "ABOUT SOHNI JUNEJA",
    line302: "/img/line-30-1@2x.png",
    junejasohniGmailCom: "junejasohni@gmail.com",
    phone1: "+91-9999963537",
    phone2: "+91-9999963537",
    rectangle90: "/img/rectangle-90@2x.png",
    bridalLook2: "BRIDAL LOOK",
    event: "Event:",
    artist: "Artist:",
    payXxxxAmountNow: "*Pay xxxx amount now and pay remaining on the day of appointment.",
    payFullAmountTo: "*Pay full amount to confirm appointment.",
    selectDate: "Select Date:",
    selectTime: "Select Time:",
    advanceBooking: "Advance Booking",
    fullPayment: "Full Payment",
    location: "Location:",
    selectPaymentOption: "Select Payment Option",
    contactUs: "Contact Us",
    proceedToPayment: "PROCEED TO PAYMENT",
    bookAppointment: "BOOK APPOINTMENT",
    ddMmYyyy: "DD/MM/YYYY*",
    select1: "Select",
    bridalLook3: "Bridal Look",
    select2: "Select",
    select3: "Select",
    vector3: "/img/vector-11@2x.png",
    vector4: "/img/vector-12@2x.png",
    vector5: "/img/vector-12@2x.png",
    vector6: "/img/vector-12@2x.png",
    line36: "/img/line-36@2x.png",
    whatsapp: "/img/whatsapp@2x.png",
    line37: "/img/line-37@2x.png",
    line38: "/img/line-37@2x.png",
    sjStudioDelhi: "SJ Studio Delhi",
    sjStudioDehradun: "SJ Studio Dehradun",
    otherEnterBelow: "Other (Enter Below)",
    pincode: "Pincode",
    state: "State",
    locality: "Locality",
    areaAndStreet: "Area and Street",
    cityTownDistrict: "City/ Town/ District",
    nearbyLandmark: "Nearby Landmark",
    submit: "Submit",
    vector7: "/img/vector-43@2x.png",
    loremIpsumDolorSi: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec posuere mauris, ut lacinia lectus. Donec ut enim mauris. Sed molestie Lorem ipsum dolor sit amet,",
    sohniJuneja: "Sohni Juneja",
    rectangle692: "/img/rectangle-69-1@2x.png",
    readMore: "Read More",
};

